import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { kevinVanDam } from "@/lib/celebrity-results/kevin-vandam";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Kevin VanDam Hair Transplant Results | RESTORE Hair";
const DESC = "Learn why Fisherman Kevin VanDam came to RESTORE to get his hair transplant. See behind the scene photos and videos directly from him!";
const POSTER = "/img/r/wp-2024-09-kevinvandam-after-05-3-1.webp";

export const Route = createFileRoute("/results/kevin-vandam")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/kevin-vandam/" },
      { property: "og:image", content: absoluteUrl(POSTER) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(POSTER) },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/kevin-vandam/" },
    ],
  }),
  component: () => <CelebrityResultPage data={kevinVanDam} />,
});
